module.exports = __webpack_public_path__ + "img/product2_007FFF_range.f6e659a7.png";